import { InjectionToken } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { AdminFinancialRequest, AdminFinancialRequestAssigneeCategory } from '@pt/models';

import {
  ChangeRequestStatusReq,
  ChangeRequestStatusRes,
  CreateRequestReq,
  CreateRequestRes,
  GetFinancialCategoriesRes,
  GetLocationsRes,
  GetRequestDetailsEncryptedDataReq,
  GetRequestDetailsEncryptedDataRes,
  GetRequestDetailsReq,
  GetRequestDetailsRes,
  GetRequestIdHashRes,
  GetRequestsReq,
  GetRequestsRes,
  GetUsersByIdsReq,
  GetUsersByIdsRes,
  SaveRequestEncryptedData,
} from '../models';
import { GetAssigneesRes } from '../models/get-assignees-res.model';
import { GetTeamsRes } from '../models/get-teams-res.model';
import { GetFunctionsRes } from '../models/get-functions-res.model';
import { GetServicesRes } from '../models/get-services-res.model';
import { GetBusinessUnitsRes } from '../models/get-business-units-res.model';

export interface FinancialRequestsApi {
  getRequestIdHash(): Observable<GetRequestIdHashRes>;

  createRequest(params: CreateRequestReq): Observable<CreateRequestRes>;

  patchRequestAssigneeCategory(
    id: number,
    params: AdminFinancialRequestAssigneeCategory
  ): Observable<AdminFinancialRequest>;

  saveRequestEncryptedData(
    params: SaveRequestEncryptedData,
  ): Observable<SaveRequestEncryptedData>;

  getRequests(params: GetRequestsReq, isAssignedToMe?: boolean): Observable<GetRequestsRes>;

  downloadReport(params: GetRequestsReq, isAssignedToMe: boolean): Observable<HttpResponse<Blob>>;

  getLocations(): Observable<GetLocationsRes>;

  getTeams(): Observable<GetTeamsRes>;

  getFunctions(): Observable<GetFunctionsRes>;

  getServices(): Observable<GetServicesRes>;

  getBusinessUnits(): Observable<GetBusinessUnitsRes>;

  getFinancialCategories(): Observable<GetFinancialCategoriesRes>;

  getAssignees(): Observable<GetAssigneesRes>;

  getRequestDetails(params: GetRequestDetailsReq): Observable<GetRequestDetailsRes>;

  getRequestDetailsEncryptedData(
    params: GetRequestDetailsEncryptedDataReq,
  ): Observable<GetRequestDetailsEncryptedDataRes>;

  getUsersByIds(params: GetUsersByIdsReq): Observable<GetUsersByIdsRes>;

  changeRequestStatus(params: ChangeRequestStatusReq): Observable<ChangeRequestStatusRes>;
}

export const FINANCIAL_REQUESTS_API = new InjectionToken<FinancialRequestsApi>(
  'FINANCIAL_REQUESTS_API',
);
